import { useAuth } from '@shared/common/providers/AuthProvider';

import type { DialogProps } from '@radix-ui/react-dialog';
import { TicketsList, TicketsListSkeleton } from '@store:web/components/entities/rewardPool';
import { CustomDialog, DialogCancelButton } from '@ui/uikit/components/common/Dialog';

import { useRoundTickets } from '../../../model/web3Raffle/api/useRoundTickets';

type Props = DialogProps & {
  closeModal: () => void;
  roundId: bigint;
};

export const ViewMyTicketsModal = ({ roundId, ...props }: Props) => {
  const { userEvmWallet } = useAuth();

  const { data: ticketsInfo } = useRoundTickets(roundId, userEvmWallet?.attributes?.address);

  return (
    <CustomDialog
      {...props}
      title={
        <div>
          My Tickets for <span className="inline-block">Raffle #{String(roundId)}</span>
        </div>
      }
      titleIsLeftAligned
      noSidePadding
      size="sm"
      footer={<DialogCancelButton className="max-sm">Close</DialogCancelButton>}
    >
      <div className="h-[500px] max-h-[55vh] overflow-auto p-6 flex flex-col gap-6">
        {ticketsInfo ? (
          <>
            {ticketsInfo.wonTicket && ticketsInfo.prizeInSqr.value > 0 ? (
              <TicketsList
                title="Winning Ticket"
                tickets={[{ code: String(ticketsInfo.wonTicket), isWinner: true }]}
                showWinText={false}
                extraBottom={
                  <div className="text-caption-sm-a">
                    <span>
                      My Reward:{' '}
                      <span className="text-base-text-orange">
                        +{ticketsInfo.prizeInSqr.formatted}
                      </span>
                    </span>
                    {ticketsInfo.prizeInUsdt.value > 0 && (
                      <span className="text-base-text-tertiary">
                        {' '}
                        (~{ticketsInfo.prizeInUsdt.formatted})
                      </span>
                    )}
                  </div>
                }
              />
            ) : null}
            {ticketsInfo.nonWonTickets.length > 0 && (
              <TicketsList
                title="All My Tickets"
                tickets={ticketsInfo.nonWonTickets.map((ticket) => {
                  return {
                    code: String(ticket),
                    isWinner: false,
                  };
                })}
              />
            )}
          </>
        ) : (
          <TicketsListSkeleton title="All My tickets" />
        )}
      </div>
    </CustomDialog>
  );
};
